import { FC, useEffect, useMemo } from 'react';
import { useAuth } from 'oidc-react';
import { USER_MANAGEMENT_ASSET_NAMES } from '../../iac/constants';
import styled from 'styled-components';
import { getEasyLayout, useApplicationStateLoader, useApplicationStateValue } from '@resistdesign/voltra/app/utils';
import { useProfileRPCs } from './Profile';
import { PROFILE } from './Profile/IDs';
import { Profile } from '../../common/Types';
import { PositionID } from '../../common/Positions/Constants';

const {
  GROUPS: { ADMIN: USER_MANAGEMENT_ADMIN_GROUP },
} = USER_MANAGEMENT_ASSET_NAMES;

const LayoutBase = styled.div`
  width: 100vw;
  height: 100vh;
`;
const AreaBase = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const {
  layout: Layout,
  areas: { CenterContent },
} = getEasyLayout(LayoutBase, AreaBase)`
  center-content, 1fr
  \\ 1fr
`;

export type OAuthState = {
  position_id?: PositionID;
  id_code?: string;
};

export type LoginCompleteProps = {
  authorization: string;
  setOAuthState: (state: OAuthState) => void;
};

export const LoginComplete: FC<LoginCompleteProps> = ({ authorization, setOAuthState }) => {
  const { profileRPC } = useProfileRPCs({ authorization });
  const { value: profile } = useApplicationStateValue(PROFILE.READ);
  const { userData } = useAuth();
  const { profile: authProfile, state: oAuthState } = userData || {};
  const {
    // @ts-ignore
    'cognito:groups': authGroups = [],
  } = authProfile || {};
  const isAdmin = authGroups.includes(USER_MANAGEMENT_ADMIN_GROUP);
  const { latestError: profileError } = useApplicationStateLoader({
    identifier: PROFILE.READ,
    remoteProcedureCall: profileRPC,
  });
  const hasState = useMemo(() => {
    try {
      return new URL(window.location.href).searchParams.has('state');
    } catch (error) {
      return false;
    }
  }, [window.location.href]);

  if (!hasState) {
    history.pushState({}, '', '/');
  }

  useEffect(() => {
    if (oAuthState) {
      setOAuthState(oAuthState as OAuthState);
    }
  }, [oAuthState, setOAuthState]);

  useEffect(() => {
    if ((profile || profileError) && userData) {
      if (isAdmin) {
        history.pushState({}, '', '/admin');
      } else {
        const { complete }: Partial<Profile> = profile || {};

        if (complete) {
          history.pushState({}, '', '/interview');
        } else {
          history.pushState({}, '', '/profile');
        }
      }
    }
  }, [profile, profileError, userData, isAdmin]);

  return (
    <Layout>
      <CenterContent>
        <h3>Login Complete...</h3>
      </CenterContent>
    </Layout>
  );
};
